import { render, staticRenderFns } from "./RoomComponent.vue?vue&type=template&id=86a51c08&scoped=true&"
import script from "./RoomComponent.vue?vue&type=script&lang=js&"
export * from "./RoomComponent.vue?vue&type=script&lang=js&"
import style0 from "./RoomComponent.vue?vue&type=style&index=0&id=86a51c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a51c08",
  null
  
)

export default component.exports